import { Toaster } from "@/components/ui/sonner";
import UpgradeModal from "@/components/Pricing/upgrade-modal";
import { Tooltip } from "react-tooltip";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import PromoCodeModal from "@/components/PromoCodeModal";

export default function MainLayout({ children }: { children?: any }) {
  const [searchParams, setSearchParams] = useSearchParams();

  // --- Promo code modal state ---
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [promoCode, setPromoCode] = useState<string | null>(null);

  // Check for promo code in URL parameters
  useEffect(() => {
    const promoParam = searchParams.get("promo");
    if (promoParam) {
      setPromoCode(promoParam);
      setShowPromoModal(true);
      // Clean up URL parameter after opening modal
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.delete("promo");
        return newParams;
      });
    }
  }, [searchParams, setSearchParams]);

  return (
    <>
      {/* Make sure toaster appears above modals */}
      <div className="w-full h-full fixed z-1000 pointer-events-none">
        <Toaster
          position={"top-right"}
          gap={8}
          theme={"light"}
          style={{
            // @ts-ignore
            "--width": "225px",
          }}
          duration={5000}
          toastOptions={{
            className: "pointer-events-auto",
          }}
        />
        <Tooltip
          id="tooltip"
          style={{
            backgroundColor: "black",
            color: "white",
            fontSize: "0.625rem",
            lineHeight: "0.5rem",
            fontWeight: 500,
            padding: "0.5rem",
          }}
          globalCloseEvents={{
            escape: true,
            scroll: true,
            clickOutsideAnchor: true,
            resize: true,
          }}
          delayShow={500}
          delayHide={150}
        />
      </div>
      <div
        style={{
          width: "100vw",
          height: "100vh",
          position: "fixed",
        }}
      >
        {children}
        <UpgradeModal />
        {showPromoModal && (
          <PromoCodeModal
            open={showPromoModal}
            onOpenChange={setShowPromoModal}
            promoCode={promoCode?.toLowerCase()}
          />
        )}
      </div>
    </>
  );
}
